import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getAnnouncementsList = async (params:Record<string,any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.ANNOUNCEMENT.GET_ANNOUNCEMENT_LIST}`,{params});
    return response.data;
}
export const getAnnouncementsByID = async (id:number) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.ANNOUNCEMENT.GET_ANNOUNCEMENT_BY_ID}/${id}`);
    return response.data;
}
export const addAnnouncement = async (body:Record<string,any>) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.ANNOUNCEMENT.ADD_ANNOUNCEMENT}`,body);
    return response.data;
}
export const updateAnnouncement = async (body:Record<string,any>,id:number) => {
    console.log('body',body,id)
    let response = await axiosInstance.put(`${API_ENDPOINTS.ANNOUNCEMENT.UPDATE_ANNOUNCEMENT}/${id}`,body);
    return response.data;
}

export const announcementPushNotification=async(body:Record<string,any>)=>{
    let response=await axiosInstance.post(API_ENDPOINTS.ANNOUNCEMENT.ANNOUNCEMENT_PUSH_NOTIFICATION,body);
    return response.data;
}